export const getWidth = (element: HTMLElement) =>
  element ? element.getBoundingClientRect().width : 0;
